import React, { useState } from 'react';
import usePublicShop from 'hooks/usePublicShop';
import {
  PaymentMethodBlockView,
  PaymentMethods
} from './PaymentMethodBlock.view';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from 'store/reducers';
import { MainFormState } from 'types/forms/form.def';
import { addClient as addClientAction } from 'store/actions';
import { errorAndStateParams } from 'helpers/forms/errorAndStateParams';

export const PaymentMethodBlock = ({
  defaultValue,
  onChange
}: {
  defaultValue?: PaymentMethods;
  onChange?: (e: string) => void;
}) => {
  const [selected, setSelected] = useState<PaymentMethods | null>(defaultValue);
  const { isPublicShop } = usePublicShop();
  const { client } = useSelector((state: AppState) => state);
  const dispatch = useDispatch();
  const addClient = (newParams: MainFormState<any>) =>
    dispatch(addClientAction(newParams));

  const handleChange = async e => {
    const value = e.target.value;
    const field = e.target.name;

    if (client.values.affilie || !client.values.livraisonhorslycee) {
      client.errors = {
        ...client.errors,
        mobilelivraison: false,
        nomlivraison: false,
        prenomlivraison: false
      };
    }

    const newParams = errorAndStateParams(field, value, client);
    addClient(newParams);
  };

  const handleChangePaymentMethod = value => {
    const e = {
      target: {
        value: value,
        name: 'methodepaiement'
      }
    };
    if (onChange) {
      onChange(value);
    }
    handleChange(e);
  };

  const onChangeMethod = (value: PaymentMethods) => {
    setSelected(value);
    handleChangePaymentMethod(value);
  };

  return (
    <>
      <PaymentMethodBlockView
        isPublicShop={isPublicShop}
        selected={selected}
        setSelected={onChangeMethod}
      />
    </>
  );
};
